import { defineStore } from 'pinia'
import GroupService from '../service/GroupService';
const groupService = new GroupService();
export const useGroupsStore = defineStore({
    id: 'group',
    state: () => ({
        groupList: null,
        singleGroup: null,
        deviceList: null,
        paginator_page: 1,
        paginator_size: 50,
        paginator_first: 1,
        sort_fields: 'creationTime',
        sort_order: -1
    }),
    getters: {
        getGroupList(state) {
            return state.groupList;
        },
        getSingleGroup(state) {
            return state.singleGroup;
        },
        getDeviceList(state) {
            return state.deviceList;
        },
        getGroupPaginatorPage: (state) => {
            return state.paginator_page;
        },
        getGroupPaginatorSize: (state) => {
            return state.paginator_size;
        },
        getGroupPaginatorFirst: (state) => {
            return state.paginator_first;
        },
        getGroupSortObject: (state) => {
            return state.sort_object;
        },
        getGroupSortFields: (state) => {
            return state.sort_fields;
        },
        getGroupSortOrder: (state) => {
            return state.sort_order;
        }
    },
    actions: {
        setGroupSortFields(sort_fields) {
            this.sort_fields = sort_fields;
        },
        setGroupSortOrder(sort_order) {
            this.sort_order = sort_order;
        },
        setGroupPaginatorPage(paginator_page) {
            this.paginator_page = paginator_page;
        },
        setGroupPaginatorSize(paginator_size) {
            this.paginator_size = paginator_size;
        },
        setGroupPaginatorFirst(paginator_first) {
            this.paginator_first = paginator_first;
        },
        setGroupSortObject(sort_object) {
            this.sort_object = sort_object;
        },
        async createGroupList() {
            let responseData = await groupService.getGroups();
            this.groupList = responseData;
            return responseData;
        },
        async createGroup(data) {
            return await groupService.createGroup(data);
        },
        async deleteSingleGroup(id) {
            return await groupService.deleteGroup(id);
        },
        async getGroupById(id) {
            this.singleGroup = await groupService.getGroupById(id);
            return this.singleGroup;
        },
        async modifySingleGroup(payload) {
            this.singleGroup = await groupService.setSingleGroup(payload);
            return this.singleGroup;
        },
    }
})